import React, { useMemo, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';

export const NestedFieldProxy = forwardRef(({ name, value = {}, onChange, component, componentProps = {} }, ref) => {
  const formRef = useRef();
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useImperativeHandle(ref, () => formRef.current, [formRef.current]);

  useEffect(
    function handleValueChange() {
      formRef.current?.setFieldsValue?.(value);
    },
    [value]
  );

  const Component = useMemo(() => {
    return Form.create({
      name,
      onValuesChange: (props, changedValues, allValues) => {
        onChangeRef.current(allValues);
      }
    })(component);
  }, [component, name]);

  return useMemo(() => <Component {...componentProps} wrappedComponentRef={form => (formRef.current = form)} />, [
    componentProps,
    Component
  ]);
});
